import { acessType, backendPermssionTypes } from 'Components/PermissionWrapper/constants';
import { checkIsPremiumPlan } from './checkPlan.helper';
import { DELETED_COMPANY } from './constants';
import { getCsvDataWithFileName } from './csv.helper';
import { formatDateToHHMMDDMMYYYY, sortByDate, sortByDateWithTime } from './date.helper';
import { escapeQuotes } from './string.helper';
import { AdminAccessLevel, AdminRoleTeamMember } from 'store/constant';

export const removeDuplicatesFromArray = (arrayData) => {
    const uniquePosts = [];
    const seenIds = {};
    for (const arrayDatum of arrayData) {
        if (!seenIds[arrayDatum._id]) {
            uniquePosts.push(arrayDatum);
            seenIds[arrayDatum._id] = true;
        }
    }
    return uniquePosts;
};

export const removeDuplicatesAndModifiedFromLatestArray = (arrayData) => {
    let uniquePosts = [];
    const seenIds = {};
    for (const arrayDatum of arrayData) {
        if (!seenIds[arrayDatum._id]) {
            uniquePosts.push(arrayDatum);
            seenIds[arrayDatum._id] = true;
        } else {
            uniquePosts = uniquePosts.map((uniquePost) => {
                const foundItem = uniquePost._id === arrayDatum._id;
                if (foundItem) {
                    return { ...uniquePost, ...arrayDatum };
                }
                return uniquePost;
            });
        }
    }
    return uniquePosts;
};

export const sortByPriority = (items) => {
    return items.sort(function (a, b) {
        return b.boardPriority - a.boardPriority;
    });
};

export const removeSpecificItemFromArray = (arr, idToRemove) => {
    const newArray = arr.filter((item) => item._id !== idToRemove);
    return newArray;
};

export const removeItemsFromArray = (arr, enquiriesIds) => {
    return arr.filter((item) => !enquiriesIds.includes(item._id));
};

export const changeAddedToRegistry = (arr, idToChange) => {
    return arr.map((item) => {
        if (item._id === idToChange) {
            return {
                ...item,
                addedToRegistry: true
            };
        } else return item;
    });
};

export const changeArchivedByToEnquiries = (arr, idsToChange, userId) => {
    return arr.map((item) => {
        if (idsToChange.find((idToChange) => idToChange === item._id.toString())) {
            return {
                ...item,
                archivedBy: userId
            };
        } else return item;
    });
};
export const addAssignCategories = (arr, objectToChange) => {
    arr.push(objectToChange);
    return arr;
};

// export const changeAssignCategories = (arr,objectToChange) =>{
//     return arr.map((item) => {
//         if (item._id === objectToChange._id) {
//             return {
//                 ...item,
//                 enquiryCategories: objectToChange
//             };
//         } else return item;
//     });
// }

export const removeOrModifyTheEnquiriesFromList = (id, boardItems, boardStatus, isRemove) => {
    const boardItemsCopy = { ...boardItems };
    let boardItemsModified = { ...boardItemsCopy };
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (boardStatus !== boardItemsCopy[key].title) {
            return key;
        }
        let items = [...temp.items];
        if (isRemove) items = removeSpecificItemFromArray(temp.items, id);
        else items = changeAddedToRegistry(temp.items, id);
        boardItemsModified = {
            ...boardItemsModified,
            [key]: {
                ...temp,
                items
            }
        };
        return key;
    });
    return boardItemsModified;
};

export const removeOrModifyManyEnquiriesFromList = (enquiryIds, boardItems, isRemove, userId) => {
    const boardItemsCopy = { ...boardItems };
    let boardItemsModified = { ...boardItemsCopy };
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };

        let items = [...temp.items];
        if (isRemove) items = removeItemsFromArray(temp.items, enquiryIds);
        else items = changeArchivedByToEnquiries(temp.items, enquiryIds, userId);
        boardItemsModified = {
            ...boardItemsModified,
            [key]: {
                ...temp,
                items
            }
        };
        return key;
    });
    return boardItemsModified;
};
export const addToTheEnquiriesList = (boardObject, boardItems, boardStatus) => {
    const boardItemsCopy = { ...boardItems };
    let boardItemsModified = { ...boardItemsCopy };
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (boardStatus !== boardItemsCopy[key].title) {
            return key;
        }
        let items = [boardObject, ...temp.items];

        boardItemsModified = {
            ...boardItemsModified,
            [key]: {
                ...temp,
                items: items
            }
        };
        return key;
    });
    return boardItemsModified;
};

export const getCategoriesIdsFromAssigneCategories = (assignedCategories) => {
    if (!assignedCategories && !assignedCategories?.length) return [];
    return assignedCategories.map((assignedCategory) => assignedCategory._id);
};

export const getAsigneeIdsFromEnquiries = (asignees) => {
    if (!asignees && !asignees?.length) return [];
    return asignees.map((asignee) => asignee._id);
};

export const getCardIdFromBoardIdAndIndex = (boardId, boardItems, index) => {
    const boardItemsCopy = { ...boardItems };
    let cardId = null;

    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (key !== boardId) {
            return key;
        }
        let items = [...temp.items];
        let cardItem = items?.find((item, idx) => idx === index);
        if (cardItem) {
            cardId = cardItem?._id;
        }
        return key;
    });
    return cardId;
};
export const getCardFromBoardById = (cardId, boardStatus, boardItems) => {
    const boardItemsCopy = { ...boardItems };
    let card = null;

    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (typeof boardStatus === 'string') {
            if (boardItemsCopy[key].title !== boardStatus) {
                return key;
            }
        }

        let items = [...temp.items];
        let cardItem = items?.find((item, idx) => item?._id === cardId);
        if (cardItem) {
            card = cardItem;
        }
        return key;
    });
    return card;
};
export const addAssigneesToTheEnquiriesFromList = (enquiryId, list, boardItems, boardStatus) => {
    const boardItemsCopy = { ...boardItems };
    let boardItemsModified = { ...boardItemsCopy };
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (typeof boardStatus === 'string') {
            if (boardItemsCopy[key].title !== boardStatus) {
                return key;
            }
        } else {
            if (Array.isArray(boardStatus)) {
                if (!boardStatus.includes(boardItemsCopy[key].title)) {
                    return key;
                }
            }
        }
        let items = [...temp.items];

        items = items.map((item) => {
            let tempItem = { ...item };
            if (item._id === enquiryId) {
                tempItem = {
                    ...tempItem,
                    assignees: [...list]
                };
                return tempItem;
            }
            return item;
        });
        boardItemsModified = {
            ...boardItemsModified,
            [key]: {
                ...temp,
                items
            }
        };
        return key;
    });
    return boardItemsModified;
};

export const addCategoriesToTheEnquiriesFromList = (enquiryId, list, boardItems, boardStatus) => {
    const boardItemsCopy = { ...boardItems };
    let boardItemsModified = { ...boardItemsCopy };
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (typeof boardStatus === 'string') {
            if (boardItemsCopy[key].title !== boardStatus) {
                return key;
            }
        } else {
            if (Array.isArray(boardStatus)) {
                if (!boardStatus.includes(boardItemsCopy[key].title)) {
                    return key;
                }
            }
        }
        let items = [...temp.items];

        items = items.map((item) => {
            let tempItem = { ...item };
            if (item._id === enquiryId) {
                tempItem = {
                    ...tempItem,
                    enquiryCategories: [...list]
                };
                return tempItem;
            }
            return item;
        });
        boardItemsModified = {
            ...boardItemsModified,
            [key]: {
                ...temp,
                items
            }
        };
        return key;
    });
    return boardItemsModified;
};

export const matchArrays = (arr1, arr2) => {
    // Create a hash table from arr1
    const hashTable = {};
    for (const obj of arr1) {
        hashTable[obj._id] = obj;
    }

    // Match elements from arr2 with the hash table
    const matchedElements = [];
    for (const id of arr2) {
        if (hashTable[id]) {
            matchedElements.push(hashTable[id]);
        }
    }

    return matchedElements;
};

export const addOrRemoveAllItemsToSelectedCards = (selectedCards, boardItems, boardStatus, type) => {
    const boardItemsCopy = { ...boardItems };
    if (type === 'Add') {
        Object.keys(boardItemsCopy).map((key) => {
            let temp = { ...boardItemsCopy[key] };
            if (boardItemsCopy[key].title !== boardStatus) {
                return key;
            }
            let items = [...temp.items];

            items = items.map((item) => {
                if (!selectedCards.some((card) => card._id === item._id)) {
                    selectedCards = [...selectedCards, item];
                }
                return item;
            });

            return key;
        });
    } else {
        selectedCards = selectedCards.filter((selectedCard) => selectedCard.boardStatus !== boardStatus);
    }
    return selectedCards;
};
export const getTotalItemsOfTheGivenBoard = (boardItems, boardStatus) => {
    const boardItemsCopy = { ...boardItems };
    let count = 0;
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        if (boardItemsCopy[key].title !== boardStatus) {
            return key;
        }
        let items = [...temp.items];

        count = items.length;
        return key;
    });
    console.log(count);
    return count;
};

export const getTotalSelectedItemsForThatBoard = (selectedCards, boardStatus) =>
    selectedCards.filter((selectedCard) => selectedCard.boardStatus === boardStatus).length;

function allSelectedItemsContainingValue(selectedItems, valueId, keyToCheck) {
    return selectedItems.every((item) => {
        return item[keyToCheck].some((value) => value._id === valueId);
    });
}

export const getUniqueValueIds = (selectedItems, keyToCheck) => {
    const valueIds = new Set();
    selectedItems.forEach((item) => {
        item[keyToCheck].forEach((valueItem) => {
            valueIds.add(valueItem._id);
        });
    });
    return Array.from(valueIds);
};

export const getValuesFromAllSelectedCardOnlyIfPresentInAllCard = (selectedCards, keyToCheck) => {
    // Separate list to store values if all selected cards contain that value
    const seperateValueList = [];

    // Get all unique value IDs from selected items
    const uniqueValueIds = getUniqueValueIds(selectedCards, keyToCheck);

    // Iterate over each unique value ID
    uniqueValueIds.forEach((valueId) => {
        // Check if all selected items contain this value ID
        if (allSelectedItemsContainingValue(selectedCards, valueId, keyToCheck)) {
            // Find the value across all selected items
            const valueFound = selectedCards.reduce((foundValue, item) => {
                return foundValue || item[keyToCheck].find((value) => value._id === valueId);
            }, null);
            if (valueFound) {
                // Add the corresponding value to the separate list
                seperateValueList.push(valueFound);
            }
        }
    });
    return seperateValueList;
};

export const convertFileListToFileArray = (fileList) => {
    let fileArray = [];
    for (let count = 0; count < fileList.length; count++) {
        fileArray.push(fileList[count]);
    }
    return fileArray;
};
export const findDataIfItAlreadyExist = (arrayOfList, itemToFind) => {
    return arrayOfList?.find((item) => item === itemToFind);
};

export const removeDataIfAlreadyExist = (arrayOfList, itemToFind) => {
    return arrayOfList?.filter((item) => item !== itemToFind);
};

export const removeDataIfAlreadyExistWithId = (arrayOfList, itemToFind, keyToCheck) => {
    return arrayOfList?.filter((item) => item[keyToCheck] !== itemToFind[keyToCheck]);
};

export const isValueChecked = (arrayItems, item, keyToCheck) => {
    const found = arrayItems.find((val) => val[keyToCheck] === item[keyToCheck]);
    return Boolean(found);
};

export const addAssignedOrRemoveListFromListArray = (originalArray = [], itemToCheck = {}, keyToCheck = '', type = '') => {
    let modifiedArray = originalArray.map((orgArr) => ({ ...orgArr })); // Create a copy of the original array with copied objects

    modifiedArray.forEach((element, index) => {
        if (isValueChecked(element[keyToCheck], itemToCheck, '_id')) {
            if (type === 'Remove' && Array.isArray(element[keyToCheck])) {
                modifiedArray[index][keyToCheck] = removeDataIfAlreadyExistWithId(element[keyToCheck], itemToCheck, '_id');
            }
        } else {
            if (type === 'Add' && Array.isArray(element[keyToCheck])) {
                modifiedArray[index][keyToCheck] = [...element[keyToCheck], itemToCheck];
            }
        }
    });

    return modifiedArray;
};

export const addAssignedCategoriesOrStaffListFromListArray = (originalArray = [], itemToCheck = [], keyToCheck = '', id) => {
    let modifiedArray = originalArray.map((orgArr) => ({ ...orgArr })); // Create a copy of the original array with copied objects

    modifiedArray.forEach((element, index) => {
        if (element._id === id) modifiedArray[index][keyToCheck] = itemToCheck;
    });

    return modifiedArray;
};
export const getIdsOnly = (items) => {
    return items?.map((item) => item._id);
};

export const getArrayToTheGivenLength = (arrayItems, limit) => {
    return arrayItems?.filter((_, index) => index < limit);
};

export const formatCsvHeadersAndData = (engagementCsvData, plan) => {
    const zipfilesArray = [];
    Object.keys(engagementCsvData).map((key) => {
        if (key === 'announcementsData') {
            if (engagementCsvData?.[key]) {
                const individualHeaders = [
                    'Date viewed               ',
                    'Investor first name',
                    'Investor last name',
                    'Investor type',
                    'Announcement viewed'
                ];
                const headers = [
                    'Time                      ',
                    'Announcement views(current)',
                    'Announcement views(potential)',
                    'Total announcement views(current and potential)'
                ];
                const data = [];
                const detailData = [];
                let datas = [...(engagementCsvData?.[key]?.data || [])];

                datas.sort(sortByDate);
                datas.map((item) => {
                    data.push([`${item.date}`, item.current, item.potential, item.total]);
                    return item;
                });
                let breakDown = [...(engagementCsvData?.[key]?.dataBreakDown || [])];
                breakDown.sort(sortByDateWithTime);
                breakDown.map((item) => {
                    detailData.push([
                        formatDateToHHMMDDMMYYYY(item.date).toString(),
                        item.firstName,
                        item.lastName,
                        item?.title ? item.investorStatus : DELETED_COMPANY,
                        `"${escapeQuotes(item?.title || '')}"`
                    ]);
                });
                zipfilesArray.push(getCsvDataWithFileName({ headers, data }, 'Announcement overall views'));
                zipfilesArray.push(
                    getCsvDataWithFileName({ headers: individualHeaders, data: detailData }, 'Announcement views break down')
                );
            }
        }
        if (key === 'companyEngagementData') {
            if (engagementCsvData?.[key]) {
                const individualHeaders = ['Date of view              ', 'Investor first name', 'Investor last name', 'Investor type'];
                const headers = [
                    'Time                ',
                    'Company profile views(current)',
                    'Company profile views(potential)',
                    'Total company profile views(current and potential)'
                ];
                const data = [];
                const detailData = [];
                let datas = [...(engagementCsvData?.[key]?.data || [])];

                datas.sort(sortByDate);
                datas.map((item) => {
                    data.push([`${item.date}`, item.current, item.potential, item.total]);
                    return item;
                });
                let breakDown = [...(engagementCsvData?.[key]?.dataBreakDown || [])];
                breakDown.sort(sortByDateWithTime);
                breakDown.map((item) => {
                    detailData.push([
                        formatDateToHHMMDDMMYYYY(item.date).toString(),
                        item.firstName,
                        item.lastName,
                        item?.investorStatus || DELETED_COMPANY
                    ]);
                });
                zipfilesArray.push(getCsvDataWithFileName({ headers, data }, 'Company overall views'));
                zipfilesArray.push(getCsvDataWithFileName({ headers: individualHeaders, data: detailData }, 'Company views breakdown'));
            }
        }
        if (key === 'investorData') {
            if (engagementCsvData?.[key]) {
                const individualHeaders = ['Time active          ', 'Investor first name', 'Investor last name', 'Investor type'];
                const headers = ['Time', 'Active users(current)', 'Active users(potential)', 'Total active users(current and potential)'];
                const data = [];
                const detailData = [];
                let datas = [...(engagementCsvData?.[key]?.data || [])];
                datas.sort(sortByDate);
                datas.map((item) => {
                    data.push([`${item.date}`, item.current, item.potential, item.total]);
                    return item;
                });
                let breakDown = [...(engagementCsvData?.[key]?.dataBreakDown || [])];
                breakDown.sort(sortByDateWithTime);
                breakDown.map((item) => {
                    detailData.push([
                        formatDateToHHMMDDMMYYYY(item.date).toString(),
                        item.firstName,
                        item.lastName,
                        item?.investorStatus || DELETED_COMPANY
                    ]);
                });
                zipfilesArray.push(getCsvDataWithFileName({ headers, data }, 'Active investors overall'));
                zipfilesArray.push(getCsvDataWithFileName({ headers: individualHeaders, data: detailData }, 'Active investors break down'));
            }
        }
        if (key === 'investorSatisfactionData' && checkIsPremiumPlan(plan)) {
            if (engagementCsvData?.[key]) {
                const individualHeaders = [
                    'Time rated                    ',
                    'Investor first name',
                    'Investor last name',
                    'Investor type',
                    'Question scored by investor',
                    'Satisfaction rating'
                ];
                const headers = [
                    'Time               ',
                    'Satisfied(current)',
                    'Satisfied(potential)',
                    'Unsatisfied(current)',
                    'Unsatisfied(potential)',
                    'Total satisfied(current and potential)',
                    'Total unsatisfied(current and potential)'
                ];
                const data = [];
                const detailData = [];
                let datas = [...(engagementCsvData?.[key]?.data || [])];
                datas.sort(sortByDate);
                datas.map((item) => {
                    data.push([
                        item.date,
                        item.currentSatisfied,
                        item.potientialSatisfied,
                        item.currentUnsatisfied,
                        item.potientialUnsatisfied,
                        item.totalSatisfied,
                        item.totalUnstatisfied
                    ]);
                    return item;
                });
                let breakDown = [...(engagementCsvData?.[key]?.dataBreakDown || [])];
                breakDown.sort(sortByDateWithTime);
                breakDown.map((item) => {
                    detailData.push([
                        formatDateToHHMMDDMMYYYY(item.date).toString(),
                        item.firstName,
                        item.lastName,
                        item?.title ? item.investorStatus : DELETED_COMPANY,
                        `"${escapeQuotes(item?.title || '')}"`,
                        item.rating
                    ]);
                });
                zipfilesArray.push(getCsvDataWithFileName({ headers, data }, 'Investor satisfaction overall'));
                zipfilesArray.push(
                    getCsvDataWithFileName({ headers: individualHeaders, data: detailData }, 'Investor satisfaction break down')
                );
            }
        }
    });
    return zipfilesArray;
};
export const removeOrModifyTheEnquiriesFromListForAllBoard = (boardItemsMod, categoryId, categoryObject, isRemove) => {
    const boardItemsCopy = { ...boardItemsMod };
    let boardItemsModified = { ...boardItemsCopy };
    Object.keys(boardItemsCopy).map((key) => {
        let temp = { ...boardItemsCopy[key] };
        let items = [...temp.items];
        items = items.map((item) => {
            let tempItem = { ...item };
            let foundCategory = item?.enquiryCategories?.find((cat) => cat._id === categoryId);
            if (foundCategory) {
                if (isRemove) {
                    tempItem = {
                        ...tempItem,
                        enquiryCategories: removeSpecificItemFromArray(item.enquiryCategories, foundCategory._id)
                    };
                } else {
                    const modifiedCategories =
                        item?.enquiryCategories?.map((enqCat) => {
                            if (foundCategory._id === enqCat._id) {
                                return {
                                    ...enqCat,
                                    ...categoryObject
                                };
                            }
                            return enqCat;
                        }) || [];
                    tempItem = { ...tempItem, enquiryCategories: [...modifiedCategories] };
                }
                return tempItem;
            }
            return item;
        });
        boardItemsModified = {
            ...boardItemsModified,
            [key]: {
                ...temp,
                items
            }
        };
        return key;
    });
    return boardItemsModified;
};

export const getPermissionData = (type, isFree) => {
    switch (type) {
        case AdminRoleTeamMember.ADMIN:
            return [
                {
                    name: backendPermssionTypes.createEvent,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },

                {
                    name: backendPermssionTypes.questionManagement,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.inviteStaff,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.administrative,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.announcements,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.calendar,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.myTeam,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.questionRegistries,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.questionBoard,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.diologIntegration,
                    allowed: true,
                    acessType: !isFree ? AdminAccessLevel.FULL : AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.companyDetails,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                }
            ];
        case AdminRoleTeamMember.MEMBER:
            return [
                {
                    name: backendPermssionTypes.createEvent,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },

                {
                    name: backendPermssionTypes.questionManagement,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.inviteStaff,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.administrative,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.announcements,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.calendar,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.myTeam,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.questionRegistries,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.questionBoard,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                },
                {
                    name: backendPermssionTypes.diologIntegration,
                    allowed: true,
                    acessType: !isFree ? AdminAccessLevel.FULL : AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.companyDetails,
                    allowed: true,
                    acessType: AdminAccessLevel.FULL
                }
            ];
        case AdminRoleTeamMember.VIEWER:
            return [
                {
                    name: backendPermssionTypes.createEvent,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },

                {
                    name: backendPermssionTypes.questionManagement,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.inviteStaff,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.administrative,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.announcements,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.calendar,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.myTeam,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.questionRegistries,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.questionBoard,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                },
                {
                    name: backendPermssionTypes.diologIntegration,
                    allowed: true,
                    acessType: !isFree ? AdminAccessLevel.VIEW : AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.companyDetails,
                    allowed: true,
                    acessType: AdminAccessLevel.VIEW
                }
            ];
        case AdminRoleTeamMember.CUSTOM:
        default:
            return [
                {
                    name: backendPermssionTypes.createEvent,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },

                {
                    name: backendPermssionTypes.questionManagement,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.inviteStaff,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.administrative,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.announcements,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.calendar,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.myTeam,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.questionRegistries,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.questionBoard,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.diologIntegration,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                },
                {
                    name: backendPermssionTypes.companyDetails,
                    allowed: false,
                    acessType: AdminAccessLevel.NONE
                }
            ];
    }
};
